import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import URI from "URI/URI";
import search_utils from "ulysses/widgets/search/utils";
import markup from "ulysses/widgets/indicators/indicator.html";

"use strict";
$(document).ready(function() { $(markup).appendTo($("body")); });

var select_indicator = function select_indicator(current_data) {
    var res = Promise.Deferred();
    var cdata = ko.toJS(current_data) || {};

    if (typeof cdata.selection == "undefined") {
        cdata = {
            "type": "indicators",
            "classic_style": false,
            "selection": [ cdata ],
        };
    }
    var indicators =uly.api.start().follow("uly:datasets").follow("uly:indicator").done(function(indicators) {
        cdata.indicators = indicators;
        cdata.indicator_filter = ko.observable(null);
        cdata.visible_indicators = ko.pureComputed(() => {
            var filter = cdata.indicator_filter();
            var chosen = cdata.selected && cdata.selected();
            if (filter == null || filter === "")
                return indicators;
            var tokens = filter.toLowerCase().split(" ");
            return indicators.filter((i) => {
                if (!i) return false;
                if (!i.name && !i.title)
                    return false;
                if (chosen && ko.unwrap(chosen.name) == ko.unwrap(i.name))
                    return true;
                for (let tok_i in tokens) {
                    let tok = tokens[tok_i];
                    if (!tok) continue;
                    if (!(
                        (i.title && i.title.toLowerCase().indexOf(tok) >= 0) ||
                        (i.name && i.name.toLowerCase().indexOf(tok) >= 0)
                    ))
                        return false;
                }
                return true;
            });
        });
        cdata.classic_style = ko.observable(cdata.classic_style);
        cdata.columns = ko.observable(ko.unwrap(cdata.columns) || 1);
        cdata.selection = ko.observableArray(cdata.selection.map((val) => {
            return {
                "indicator": ko.observable(val.indicator),
                "path": ko.observable(val.path),
                "caption": ko.observable(val.caption),
                "extra_filter": ko.observable(val.extra_filter),
                "extra_solr_filter": ko.observable(val.extra_solr_filter),
                "override_icon": ko.observable(val.override_icon || null),
                "override_colour": ko.observable(val.override_colour || null)
            };
        }));
        Object.assign(cdata, {
            is_selected: function(val) {
                return cdata.selected() == val;
            },
            selected: ko.observable(cdata.selection()[0]),
            select: function(indicator, ev) {
                cdata.selected(indicator);
            },
            addindicator: function() {
                var v = {
                    "indicator": ko.observable(null),
                    "path": ko.observable(null),
                    "caption": ko.observable(null),
                    "extra_filter": ko.observable(null),
                    "extra_solr_filter": ko.observable(null)
                };
                cdata.selection.push(v);
                cdata.select(v);
            },
            get_caption: function(v) {
                if (ko.unwrap(v.caption)) {
                    return ko.unwrap(v.caption);
                }
                if (ko.unwrap(v.indicator)) {
                    var i = indicators.filter((i) => { return i.name == ko.unwrap(v.indicator)})[0];
                    if (i) {
                        return ko.unwrap(i.title);
                    }
                }
                return  _("indicator_editor_default_caption", "Undefined");
            }
        });
        var dialog = uly.dialogs.execute($("#indicator-picker-tmpl").html() , {
            "title":_("indicator_title_select_indicator", "Select Indicator"), raw_data: true
        }, cdata).done(function([result]) {
            var selobj = ko.toJS(cdata.selection)[0] || {};
            var sourceobj = ko.toJS(cdata.indicators.filter((i) => { return i.name == selobj.indicator }))[0] || {};
            res.resolve([{
                "selection": ko.toJS(result.selection),
                "classic_style": ko.unwrap(result.classic_style),
                "columns": ko.unwrap(result.columns)
            }, {
                "icon": selobj.icon || sourceobj.icon,
                "colour": selobj.colour || sourceobj.colour,
                "caption": selobj.caption || sourceobj.title
            }]);
        }).fail(res.reject);
    }).fail(res.reject);
    return res.promise();
};
var modify_indicator = function modify_indicator(widget_model) {
    var res = Promise.Deferred();
    select_indicator(ko.unwrap(widget_model.settings)).then(function([result]) {
        var new_settings = $.extend({}, ko.unwrap(widget_model.settings), result);
        widget_model.settings(new_settings);
        uly.publish("page.savesettings");
        res.resolve(result);
    }).fail(res.reject);
    return res.promise();
};

function build_indicator_model(settings_obs) {
    var model = {
        "index": ko.observable(0),
    };
    //create observable to upgrade the settings if needed
    var settings = ko.pureComputed(() => {
        var s = ko.unwrap(settings_obs);
        var selection = ko.unwrap(s.selection);
        if (!selection) {
            return {
                "type": "indicators",
                "classic_style": false,
                "selection": [s]
            };
        } else {
            return s;
        }
    });

    model.indicators = ko.pureComputed(() => {
        return ko.unwrap(settings).selection.map((v) => {
            return  {
                "icon":ko.observable(ko.unwrap(v).icon || "fa-dashboard"),
                "colour":ko.observable(ko.unwrap(v).colour || "default"),
                "value":ko.observable(null),
                "caption":ko.observable(ko.unwrap(v).caption),
                "details_url":ko.observable(null),
                "hardcoded_model": ko.observable(null),
                "local_params": ko.observable(null),
                "indicator": ko.pureComputed(function() { return ko.unwrap(v).indicator; }),
                "search_settings": ko.observable({}),
                "path": ko.unwrap(v).path,
                "extra_filter": ko.unwrap(v).extra_filter,
                "extra_solr_filter": ko.unwrap(v).extra_solr_filter,
                "override_icon": ko.unwrap(v).override_icon,
                "override_colour": ko.unwrap(v).override_colour
            };
        });
    });
    model.classic_style = ko.pureComputed(() => { return ko.unwrap(settings).classic_style; });

    model.shown = ko.pureComputed(() => {
        var l = model.indicators().length;
        if (!l) { return null; }
        return model.indicators()[model.index() % l];
    });
    model.next = ko.pureComputed(() => {
        var l = model.indicators().length;
        if (!l) { return null; }
        return model.indicators()[(model.index()+1) % l];
        
    })
    model.search_settings = ko.pureComputed(() => {
        var s = ko.unwrap(model.shown);
        if (s) { 
            return ko.unwrap(s.search_settings);
        }
    });
    model.has_many = ko.pureComputed(() => {
        return model.indicators().length > 1;
    });
    model.show_next = () => {
        model.index(model.index() + 1);
    }
    return model;
}

function get_indicator_query(indicator_model, context) {
    var dataset = uly.api.start().follow("uly:datasets").follow("find", { "rel":ko.unwrap(indicator_model.indicator) });
    var bound = false;
    var entity = uly.utils.get_bound_resource(context);
    var path = ko.unwrap(indicator_model.path);
    var caption = indicator_model.caption.peek();
    var icon = indicator_model.override_icon;
    var colour = indicator_model.override_colour;

    var filter = ko.unwrap(indicator_model.extra_filter);
    var solr_filter = ko.unwrap(indicator_model.extra_solr_filter);
    if (path) {
        if (entity) {
            dataset = dataset.follow("uly:results", { "origin":entity.unique_id, "path":path, "filter": filter, "solr_filter": solr_filter });
            bound = true;
        }
    }
    if (!bound) {

        dataset = dataset.follow("uly:results", { "filter": filter, "solr_filter": solr_filter });
    }
    dataset._params = {
        "entity":entity, "path":path, 
        "caption":caption, "icon": icon, "colour": colour,
        "filter": filter, "solr_filter": solr_filter};
    return dataset;
}

function get_subindicator_query(indicator_model, context, queue) {
    var entity = uly.utils.get_bound_resource(context);
    var path = ko.unwrap(indicator_model.path);
    var caption = indicator_model.caption.peek();
    var icon = indicator_model.override_icon;
    var colour = indicator_model.override_colour;

    var filter = ko.unwrap(indicator_model.extra_filter);
    var solr_filter = ko.unwrap(indicator_model.extra_solr_filter);
    var dataset = queue.add_query(ko.unwrap(indicator_model.indicator), entity ? entity.unique_id : null, path, filter, solr_filter);
    dataset._params = {
        "entity":entity, "path":path, "caption":caption, 
        "icon": icon, "colour": colour,
        "filter": filter, "solr_filter": solr_filter};
    return dataset;
}

function load_indicator(indicator_model, dataset) {
    var caption = dataset._params.caption;
    var icon = dataset._params.icon;
    var colour = dataset._params.colour;
    var path  = dataset._params.path;
    var entity = dataset._params.entity;
    return dataset.then(function(result) {
        var model = indicator_model;
        result = result || {};

        model.icon(icon || result.icon);
        model.caption(caption || result.title || result.caption);
        model.colour(colour || result.colour);
        model.value(result.value);
        model.details_url(result.details || result.url);
        model.hardcoded_model(result.hardcoded_model);
        model.local_params(result.local_params);
        var filters = null;
        if (result.details || result.url) {
            //hack to stop the stupid thing interpreting our + as spaces
            var uri = (result.details || result.url).replace("+", "%2B");
            var details_uri = new URI(uri);
            filters = details_uri.query(true).filters;
            if (filters && !Array.isArray(filters))
                filters = [filters];
            else if (!filters)
                filters = [];
            if (path && entity) {
                if (path.indexOf(":") > 0) {
                    path = path.split(":")[1];
                }
                if (path.indexOf(",") > 0) {
                    filters.push(path.split(",").map((p)=> "_parents:"+entity.unique_id+"."+p).join(" OR "));
                } else {
                    filters.push("_parents:"+entity.unique_id+"."+path);
                }
                indicator_model.search_settings.contextual = true;
            }
            if (details_uri.path() && details_uri.path().indexOf("/") < 0)
            {
                if (details_uri.path() != "search")
                    filters.push("type:"+details_uri.path());
            }
            if ((filters.length) == 1)
                filters = filters[0];
            else if (filters.length > 0) {
                filters = $.map(filters, function(value) { return "(" + value + ")"; }).join(" AND ");
            }
            else filters = null;
        }
        var settings = ko.unwrap(indicator_model.search_settings);
        settings.facets_visible = false;
        settings.local_params = ko.unwrap(model.local_params);
        settings.hardcoded_model = ko.unwrap(model.hardcoded_model);
        if (settings.local_params) {
            filters = settings.local_params + (filters ||"");
        }
        if (settings.filter != filters) {
            settings.filter = filters;
            console.log("Settings search settings load indic:", settings);
            indicator_model.search_settings(settings);
        }

        if (result.icon) {
            indicator_model.icon(icon || result.icon);
        }
    });
}

ko.bindingHandlers.subindicator = {
    "init": function(elt, va, allbindings, model, context) {

        var indicator_data = build_indicator_model(va());
        //use parent's observable for search_settings if provided.
        if (allbindings().search_settings) {
            indicator_data.search_settings.subscribe((newval) => { allbindings().search_settings(search_utils.ensure_settings_complete(newval)[0]); });// = allbindings().search_settings;
        }
        $(elt).data("indicator_data", indicator_data);
        $(elt).on("dashboard:refresh", () => {
            indicator_data.index.notifySubscribers(indicator_data.index());
        });
        var child = context.createChildContext(indicator_data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        var indicator_model = $(elt).data("indicator_data");
        var index = indicator_model.index();
        var ready = allbindings().ready;
        console.log("loading indicaor");
        //var settings = ko.unwrap(va());
        var queue = ko.unwrap(allbindings().queue);
        var dataset = get_subindicator_query(indicator_model.shown(), context, queue);
        load_indicator(indicator_model.shown(), dataset).then(() => {
            if (ready) { ready.resolve(true); }
        });
        if (indicator_model.has_many()) {
            var ds_next = get_subindicator_query(indicator_model.next(), context, queue);
            load_indicator(indicator_model.next(), ds_next);
        }
    }
};

ko.bindingHandlers.indicator = {
    "init":function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.title(_("indicator_loading", "loading..."));
        widget_model.icon("fa fa-dashboard");
        widget_model.show_header(false);
        widget_model.panel_class(widget_model.panel_class().replace("box-primary", "box-no-header"));
        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption":_("indicator_caption_select_indicator", "Select Indicator"), 
            "icon":"fa-edit", 
            "action":function(e){
                modify_indicator(widget_model);
            },
            "colour":"default",
            "permission": "editpage"
        });
        var search_settings = ko.pureComputed({
            read: function() {
                var w_settings = ko.unwrap(widget_model.settings) || {};
                console.log("Creating saerch seattings:", w_settings, w_settings.search);
                var result = search_utils.ensure_settings_complete(w_settings.search || {
                    "navigable":false,
                    "contextual":false,
                    "filter":null,
                    "parameters": { _search_body:null }
                })[0];
                return result;
            },
            write: function(newvalue) {
                var w_settings = ko.unwrap(widget_model.settings) || {};
                w_settings.search = newvalue;
                widget_model.settings(w_settings);
            }
        });
        var indicator_data = build_indicator_model(widget_model.settings);
        var data = {
            indicators: indicator_data,
            "remove_action":function(ev) {
                var bindingcontext = ko.contextFor($(ev.target)[0]);
                if (context.widget_list) {
                    context.widget_list.splice(ko.unwrap(context.$index), 1);
                    uly.publish("page.savesettings");
                }
            },
            "toggle_detail_action":function(ev, ui) {
                ev.stopPropagation();
                ev.preventDefault();
                data.details_shown(!data.details_shown());
                return false;
            },
            "details_shown": ko.observable(false),
            "has_many": ko.pureComputed(() => {
                return ko.unwrap(indicator_data.indicators).length > 1;
            }),
            "show_next": function() {
                indicator_data.index(indicator_data.index() + 1);
                return false;
            },
            "search_settings": search_settings
        };

        $(elt).data("indicator_data", data);
        var child = context.createChildContext(data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        var indicator_model = $(elt).data("indicator_data").indicators;
        var query = get_indicator_query(indicator_model.shown(), context);
        load_indicator(indicator_model.shown(), query).then(function(result) {
            uly.publish("widget.active", elt);
        });
        uly.publish("widget.active", elt);
    }
};

uly.widgets.register({
    "type":"indicators",
    "caption":_("indicator_caption_indicator", "Indicator"),
    "description":_("indicator_description_a_set_of_values_showing_something", "A set of values showing something "),
    "icon":"fa-dashboard",
    "init":function() {
        var data = {
            "classic_style": ko.observable(false),
            "selection": ko.observableArray([{ "indicator":ko.observable(null), "path":ko.observable(null), "caption":ko.observable(null) }])
        };
        var init_def = Promise.Deferred();
        select_indicator(data).done(function(result) {
            result = ko.toJS(result);
            init_def.resolve(result);
        }).fail(init_def.reject);
        return init_def;
    },
    "colour":"light-sea-green"
});

uly.actions.pickindicator = function(e, $elt, ui) {
    var selected_indicator = ko.unwrap(ui.model.name);
    ui.context.$parent.indicator(selected_indicator);
    e.stopPropagation();
    return false;
};

uly.actions.changeindicator = function(e,$elt,ui) {
    modify_indicator(ui.context.$parent);
    e.stopPropagation();
    return false;
};

export default {
    select_indicator:select_indicator
};
